/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Loader/theme';

export const LoaderTheme = theme;
